'use strict'

/**
 * @module toggleBlock
 */

const CLASS_ACTIV = 'activ'
const CLASS_TRIGGER = 'js-display-block'
const CLASS_TARGET = 'js-display-block-target'
const CLASS_SCROLLING = 'js-display-block-scrolling'

const ATTRIBUTE_TARGET = 'data-target'

const SELECTOR_TRIGGER = `.${CLASS_TRIGGER}`
const SELECTOR_TARGET = `.${CLASS_TARGET}`

export default {
  /**
   * @description Initialise toggleBlock
   * @returns {undefined}
   */
  init() {
    this.bind()
  },

  /**
   * @description Bind events on toggleBlock elements
   * @returns {undefined}
   */
  bind() {
    document.getElementsByClassName(CLASS_TRIGGER).bindEvent('click', this.toggleTarget.bind(this))
    document.addEventListener('click', this.hideAll)
  },

  /**
   * @description toggle class CLASS_ACTIV on targeted element
   * @params {event} e MouseEvent
   * @returns {undefined}
   */
  toggleTarget(e) {
    e.preventDefault()
    const trigger = e.currentTarget
    const target = document.getElementById(trigger.getAttribute(ATTRIBUTE_TARGET))
    const isScrolling = trigger.classList.contains(CLASS_SCROLLING)

    if (target.classList.contains(CLASS_ACTIV)) {
      target.classList.remove(CLASS_ACTIV)
    } else {
      this.hideAll()
      target.classList.add(CLASS_ACTIV)

      if (isScrolling) {
        const offset = 150;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }

    }
  },

  /**
   * @description remove CLASS_ACTIV on all CLASS_TARGET elements
   * @returns {undefined}
   */
  hideAll(e) {
    if (e && (e.target.classList.contains(CLASS_TRIGGER)
              || e.target.closest(SELECTOR_TRIGGER)
              || e.target.classList.contains(CLASS_TARGET)
              || e.target.closest(SELECTOR_TARGET))) {
      return
    }
    const target = document.getElementsByClassName(CLASS_TARGET)
    const length = target.length
    for (let i = 0; i < length; i++) {
      target.item(i).classList.remove(CLASS_ACTIV)
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/toggleBlock.js